import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';
import Spinner from '@atlaskit/spinner';
import Placeholder from '@atlassian/jira-placeholder';
import type FormDirectoryType from './main';

export const FormDirectory = lazyForPaint<typeof FormDirectoryType>(
	() => import(/* webpackChunkName: "async-business-form-directory" */ './main'),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<Placeholder name="form-directory" fallback={<Spinner />}>
		<FormDirectory />
	</Placeholder>
);
